import { DRONEVIEW__MUTATIONS } from "../mutation-types";
import { DRONEVIEW__ACTIONS } from "../action-types";
import { DRONEVIEW__API } from "@/_helpers/urls";
import http from "@/_helpers/http";

// State
const state = {
  treeData: {},
};

// Mutations
const mutations = {
  [DRONEVIEW__MUTATIONS.DRONEVIEW](state, data) {
    state.treeData = data;
  },
};

const getters = {};

// Actions
const actions = {
  async [DRONEVIEW__ACTIONS.DRONEVIEW]({ commit }) {
    try {
      const { data } = await http().get(DRONEVIEW__API.DRONEVIEW);
      commit(DRONEVIEW__MUTATIONS.DRONEVIEW, data?.treeData);
    } catch (error) {
      console.error("Error fetching treeData:", error);
    }
  },
};

export default {
  strict: process.env.NODE_ENV !== "production",
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
